// import React from "react";
// import Select from "react-select";
// export default ({
//   name,
//   label,
//   type,
//   value,
//   initailValue,
//   checked,
//   onChange,
//   options,
//   disabled,
//   required,
//   onChecked,
//   node,
//   onSelect,
// }) => {
//   return (
//     <div className="form-group row m-1">
//       <label label className="col-lg-4 col-form-label">
//         {label}
//         {required && <span className="text-danger">*</span>}
//       </label>
//       <div className="col-lg-6">
//         {type === "select" ? (
//           name !== "node" ? (
//             <select
//               key={name}
//               className="form-control"
//               defaultValue={initailValue}
//               onChange={onChange}
//               disabled={disabled}
//             >
//               {!initailValue && <option value={null}>please-select</option>}
//               {options.map((opt) => (
//                 <option value={opt}>{opt}</option>
//               ))}
//             </select>
//           ) : (

//             <Select
//               options={node}
//               isMulti={true}
//               onChange={onSelect}
//               defaultInputValue={initailValue}
//               theme={(theme) => ({
//                 ...theme,
//                 borderRadius: 10,
//               })}
//             />
//           )
//         ) : type === "text" || type === "date" ? (
//           <input
//             key={name}
//             className="form-control"
//             type={type}
//             name={name}
//             value={value}
//             onChange={onChange}
//             defaultValue={initailValue}
//             disabled={disabled}
//             required={required}
//           />
//         ) : type === "textarea" ? (
//           <textarea
//             key={name}
//             className="form-control"
//             type={type}
//             name={name}
//             value={value}
//             rows={"3"}
//             onChange={onChange}
//             defaultValue={initailValue}
//             disabled={disabled}
//             required={required}
//           />
//         ) : type === "checkbox" ? (
//           <div className="form-check">
//             {options.map((item, idx) => (
//               <label key={idx} className="form-check-label px-3">
//                 <input
//                   type={type}
//                   className="form-check-input"
//                   onChange={(e) => onChecked(e, idx)}
//                   defaultChecked={checked[idx]}
//                   id={name}
//                   name={name}
//                   required={required}
//                 />
//                 {item.role}
//               </label>
//             ))}
//           </div>
//         ) : (
//           {}
//         )}
//       </div>
//     </div>
//   );
// };

import React from "react";
import Select from "react-select";

export default function RegisterFields({
  name,
  label,
  type,
  value,
  initailValue, // keeping your prop name as-is
  checked,
  onChange,
  options = [],
  disabled,
  required,
  onChecked,
  node = [],
  onSelect,
}) {
  // ---- SECTION HEADER ONLY ----
  if (type === "section") {
    return (
      <div className="row m-1">
        <div className="col-lg-12">
          <h5 className="mb-3">{label}</h5>
          <hr className="mt-3" />
        </div>
      </div>
    );
  }

  const getOptLabel = (opt) =>
    typeof opt === "string" ? opt : opt.label || opt.role || String(opt);
  const getOptValue = (opt) =>
    typeof opt === "string"
      ? opt
      : opt.value || opt.label || opt.role || String(opt);

  return (
    <div className="form-group row m-1">
      <label className="col-lg-4 col-form-label">
        {label}
        {required && <span className="text-danger">*</span>}
      </label>

      <div className="col-lg-6">
        {type === "select" ? (
          name !== "node" ? (
            <select
              key={name}
              className="form-control"
              defaultValue={initailValue}
              onChange={onChange}
              disabled={disabled}
              required={required}
            >
              {!initailValue && <option value="">please-select</option>}
              {options.map((opt) => (
                <option key={String(opt)} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          ) : (
            <Select
              options={node}
              isMulti={true}
              onChange={onSelect}
              // If your init value is array of strings, map to {value,label}
              defaultValue={
                Array.isArray(initailValue)
                  ? initailValue.map((v) => ({ value: v, label: v }))
                  : undefined
              }
              isDisabled={disabled}
              theme={(theme) => ({
                ...theme,
                borderRadius: 10,
              })}
            />
          )
        ) : type === "text" || type === "date" ? (
          <input
            key={name}
            className="form-control"
            type={type}
            name={name}
            // Prefer uncontrolled with defaultValue to avoid mixed warnings
            defaultValue={initailValue}
            onChange={onChange}
            disabled={disabled}
            required={required}
            // If you truly need controlled, swap to: value={value ?? ""}
          />
        ) : type === "textarea" ? (
          <textarea
            key={name}
            className="form-control mt-3"
            name={name}
            rows="3"
            defaultValue={initailValue}
            onChange={onChange}
            disabled={disabled}
            required={required}
          />
        ) : type === "checkbox" ? (
          <div className="form-check">
            {(options || []).map((item, idx) => (
              <label key={idx} className="form-check-label px-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  onChange={(e) => onChecked(e, idx)}
                  defaultChecked={checked ? checked[idx] : false}
                  id={name}
                  name={name}
                  required={required}
                  disabled={disabled}
                />
                {item.role}
              </label>
            ))}
          </div>
        ) : type === "radio" ? (
          <div className="form-check">
            {(options || []).map((opt, idx) => {
              const optLabel = getOptLabel(opt);
              const inputId = `${name}-rad-${idx}`;
              return (
                <label
                  key={idx}
                  className="form-check-label px-3"
                  htmlFor={inputId}
                >
                  <input
                    id={inputId}
                    type="radio"
                    className="form-check-input"
                    name={name} // same name = grouped
                    value={optLabel} // stored string
                    onChange={onChange}
                    required={required}
                    disabled={disabled}
                    defaultChecked={initailValue === optLabel} // ✅ preselect by initial value
                  />
                  {optLabel}
                </label>
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
}
